<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-03-07 10:35:06
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-04-09 14:29:58
-->
<template>
  <goods-detail></goods-detail>
</template>
<script>
import GoodsDetail from '@/views/shopManage/shopLibrary/detail';
export default {
  components: {
    GoodsDetail
  },
  name: 'shopGroup_details',
}
</script>